export const LABELS_TABLE_LABELS = {
	COLUMN_KEY: 'Key',
	COLUMN_DISPLAY_NAME: 'Key Display Name',
	COLUMN_TYPE: 'Label Type',
	COLUMN_VALUES: 'Values',
	COLUMN_ACTIONS: 'Actions',
	CREATE_BUTTON: 'Create Label',
	CREATE_BUTTON_DISABLED_TOOLTIP: 'Maximum number of custom labels reached.',
	EDIT_ACTION: 'Edit',
	DELETE_ACTION: 'Delete',
	ACTIONS_MENU_TRIGGER_ARIA: (key: string): string => `Actions for "${key}"`,
	EMPTY_STATE: 'No labels found',
	TABLE_TITLE: 'Labels',
	TABLE_CAPTION: 'Labels management table',
	VALUES_MODAL_CLOSE: 'Close',
	VALUES_MODAL_TITLE: (key: string): string => `Labels for key "${key}"`
} as const;
